import { CautionsTabLocationsView } from '@mark43/cad-api';
import { Icon, Spinner, Text, Box } from '@cad-arc';
import { ExpandableContent } from '../common/components/expandable-content';
import { NearbyLocationsSection as NearbyCautions } from '../event-panel/tabs/cautions/components/sections/nearby-locations-section';

export function FrEventNearbyCautions({
    areCautionsLoading,
    cautions,
    marginBottom,
}: {
    areCautionsLoading: boolean;
    cautions?: CautionsTabLocationsView;
    marginBottom?: number;
}) {
    return (
        <Box mb={marginBottom}>
            {areCautionsLoading && <Spinner />}
            {!!cautions?.nearbyCautionTabLocations?.length && (
                <ExpandableContent
                    title={
                        <Text
                            color="info"
                            fontWeight="bold"
                            style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                        >
                            <Icon size="sm" icon="Alert" />
                            {`Nearby Cautions (${cautions.nearbyCautionTabLocations.length})`}
                        </Text>
                    }
                >
                    <NearbyCautions
                        data={cautions.nearbyCautionTabLocations}
                        isLoading={!!areCautionsLoading}
                    />
                </ExpandableContent>
            )}
        </Box>
    );
}
